/**
 * Безопасная работа с localStorage
 * Предотвращает ошибки при парсинге некорректного JSON
 */

/**
 * Безопасно получить и распарсить данные из localStorage
 * @param {string} key - ключ в localStorage
 * @param {*} defaultValue - значение по умолчанию если данных нет или ошибка
 * @returns {*} распарсенные данные или defaultValue
 */
export const safeGetItem = (key, defaultValue = null) => {
    try {
        const item = localStorage.getItem(key);

        // Проверяем что значение существует и не строка "undefined" или "null"
        if (!item || item === "undefined" || item === "null") {
            return defaultValue;
        }

        return JSON.parse(item);
    } catch (error) {
        console.error(`Error parsing localStorage key "${key}":`, error);
        return defaultValue;
    }
};

/**
 * Безопасно сохранить данные в localStorage
 * @param {string} key - ключ в localStorage
 * @param {*} value - значение для сохранения
 * @returns {boolean} успешно ли сохранено
 */
export const safeSetItem = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch (error) {
        console.error(`Error saving to localStorage key "${key}":`, error);
        return false;
    }
};

/**
 * Безопасно удалить данные из localStorage
 * @param {string} key - ключ в localStorage
 * @returns {boolean} успешно ли удалено
 */
export const safeRemoveItem = (key) => {
    try {
        localStorage.removeItem(key);
        return true;
    } catch (error) {
        console.error(`Error removing localStorage key "${key}":`, error);
        return false;
    }
};

/**
 * Очистить весь localStorage безопасно
 * @returns {boolean} успешно ли очищено
 */
export const safeClear = () => {
    try {
        localStorage.clear();
        return true;
    } catch (error) {
        console.error('Error clearing localStorage:', error);
        return false;
    }
};

export default {
    getItem: safeGetItem,
    setItem: safeSetItem,
    removeItem: safeRemoveItem,
    clear: safeClear
};